import { BaseModel } from './base';

export enum RoleType {
  owner = 'owner',
  admin = 'admin',
  legacy = 'legacy',
  employee = 'employee',
  restricted = 'restrictedEmployee',
  // The legacy enum stored `custom` as numeric `6` while every other type is
  // a string. Keep both forms accepted so we work across API shapes.
  custom = 'custom',
}

export class Role extends BaseModel {
  idRole!: string;
  name!: string;
  type?: string;
  idCustomRole?: string;

  override objectID(): string {
    return this.idRole?.toString() || '';
  }

  get isRoleTypeOwner(): boolean {
    return this.type === RoleType.owner;
  }

  get isRoleTypeAdmin(): boolean {
    return this.type === RoleType.admin;
  }

  get isRoleTypeLegacy(): boolean {
    return this.type === RoleType.legacy;
  }

  get isRoleTypeEmployee(): boolean {
    return this.type === RoleType.employee;
  }

  get isRoleTypeRestrictedEmployee(): boolean {
    return this.type === RoleType.restricted;
  }

  get isRoleTypeCustom(): boolean {
    return this.type === RoleType.custom || (this.type as unknown) === 6;
  }
}
